export interface StreamOptions {
  facingMode?: "environment" | "user";
}

export async function startCameraStream(opts: StreamOptions = {}): Promise<MediaStream> {
  if (!navigator.mediaDevices?.getUserMedia) {
    throw new Error("Camera not supported in this browser");
  }
  return navigator.mediaDevices.getUserMedia({
    video: {
      facingMode: { ideal: opts.facingMode ?? "environment" },
      width: { ideal: 2560 },
      height: { ideal: 1920 }
    },
    audio: false
  });
}

export function stopStream(stream: MediaStream): void {
  for (const track of stream.getTracks()) track.stop();
}

export async function captureFrame(video: HTMLVideoElement, quality = 0.92): Promise<Blob> {
  if (video.videoWidth === 0 || video.videoHeight === 0) {
    throw new Error("Camera is not ready yet.");
  }
  const canvas = document.createElement("canvas");
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("2D context unavailable");
  ctx.drawImage(video, 0, 0);
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error("Capture encoding failed"))),
      "image/jpeg",
      quality
    );
  });
}
